import type {
  FormFieldInternalLookupResponseDTO,
  LookupEntryAddressDTO,
} from '@/api/base/DTOs';
import type { LookupEntryAddress } from '@/forms/typings';
import { getStoreState } from '@/store';

import { toInternalLookupOptionValue } from './internalLookupResponseToOptions.adapter';

/** The select's slots, each with the value of the option its lookup entry stands for. */
export const adaptLookupEntryAddresses = (
  lookupEntryAddresses: LookupEntryAddressDTO[] | null | undefined,
  internalLookup: FormFieldInternalLookupResponseDTO | undefined,
): LookupEntryAddress[] | undefined => {
  if (!lookupEntryAddresses) return undefined;

  const entries = internalLookup
    ? getStoreState().lookup.internalLookups[internalLookup.lookupTypeID]
    : undefined;

  return lookupEntryAddresses.map(({ entry, targetFieldID }) => {
    // The server names each slot by its lookup entry's name.
    const id = entries?.find(lookup => lookup.name === entry)?.id;

    return {
      entry,
      targetFieldId: targetFieldID ?? undefined,
      optionValue:
        id === undefined || !internalLookup
          ? undefined
          : toInternalLookupOptionValue(internalLookup.lookupTypeID, id),
    };
  });
};
